import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { NO_FIRM_LABEL } from './emailLabels'

export default function EmailDailyTotals({ totals = [] }) {
    return (
        <MDBox data-testid="email-daily-totals" sx={{ mb: 3 }}>
            <MDTypography variant="h6" sx={{ mb: 1 }}>סיכום יומי לפי משרד</MDTypography>
            <Table size="small">
                <TableHead sx={{ display: 'table-header-group' }}>
                    <TableRow>
                        <TableCell>משרד</TableCell>
                        <TableCell>תאריך</TableCell>
                        <TableCell align="center">נשלחו</TableCell>
                        <TableCell align="center">לא הגיעו</TableCell>
                        <TableCell align="center">סה״כ</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {totals.map((total) => (
                        <TableRow
                            key={`${total.firmId ?? 'none'}-${total.day}`}
                            data-testid={`email-total-${total.firmId ?? 'none'}-${total.day}`}
                        >
                            <TableCell>{total.firmName ?? NO_FIRM_LABEL}</TableCell>
                            <TableCell>{total.day}</TableCell>
                            <TableCell align="center">{total.sent}</TableCell>
                            <TableCell align="center">{total.failed}</TableCell>
                            <TableCell align="center">{total.total}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </MDBox>
    )
}
